module.exports = __webpack_public_path__ + "media/images/flags/16/Christmas-Island-a71bbb87909f9ccc31403a5e3e128718.png";